'use strict';

module.exports = {

    generateKeyReportByBeerStyle(infoReport) {
       let key = 'REPORT_BY_BEER_STYLES';

       if (infoReport.isShowConfirmed) {
           key += '_CONFIRMED';
       } else {
           key += '_PLANNED';
       }

        if (infoReport.isDetailedByBeerStyle) {
            key += '_SHOW_DETAIL';
        } else {
            key += '_NON_SHOW_DETAIL';
        }

        switch (infoReport.filterByOptionIndex) {
            case 0:  {
                key += '_BY_TOTAL';
                break;
            }
            case 1:  {
                key += '_BY_MONTH';
                break;
            }
            case 2:  {
                key += '_BY_WEEK';
                break;
            }
            case 3:  {
                key += '_BY_DAY';
                break;
            }
        }

        return key;
    },

    generateKeyReportByProduct(infoReport) {
       let key = 'REPORT_BY_PRODUCT';

       if (infoReport.isShowConfirmed) {
           key += '_CONFIRMED';
       } else {
           key += '_PLANNED';
       }

        switch (infoReport.filterByOptionIndex) {
            case 0:  {
                key += '_BY_TOTAL';
                break;
            }
            case 1:  {
                key += '_BY_MONTH';
                break;
            }
            case 2:  {
                key += '_BY_WEEK';
                break;
            }
            case 3:  {
                key += '_BY_DAY';
                break;
            }
        }

        return key;
    }

};



/** WEBPACK FOOTER **
 ** ./src/stores/ReportStore.js
 **/